import { Container as MaterialContainer, Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled(MaterialContainer)(({ theme }) => ({
	width: "100%",
	height: "100%",
	maxHeight: "100vh",
	padding: "0",
	marginLeft: "5rem",
	marginRight: "0rem",
	display: "grid",
	[theme.breakpoints.down("md")]: {
		marginLeft: "0",
		padding: "1rem",
		gridTemplateRows: "auto",
		gridTemplateColumns: "auto",
		gridGap: "1.5em",
		gridTemplateAreas: `"logo" "content" "rating" "gutter"`,
	},
	[theme.breakpoints.down("mobile")]: {
		backgroundColor: theme.palette.primary.light,
		paddingBottom: 0,
		maxHeight: "none",
	},
	[theme.breakpoints.up("md")]: {
		marginLeft: "3rem",
		gridTemplateRows: "20% 1fr 45% 1fr",
		gridTemplateColumns: "auto",
		gridGap: "1em",
		gridTemplateAreas: `"logo" "content" "rating" "gutter"`,
	},
	[theme.breakpoints.up("lg")]: {
		marginLeft: "5rem",
	},
}));

export const LogoContainer = styled(Grid)(({ theme }) => ({
	gridArea: "logo",
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	padding: "1rem",
	[theme.breakpoints.down("mobile")]: {
		padding: 0,
		justifyContent: "flex-start",

		columnGap: 41,
	},
}));

export const ContentContainer = styled(Grid)({
	gridArea: "content",
	display: "block",
	letterSpacing: "0",
});

export const Header = styled(Typography)(({ theme }) => ({
	fontSize: "1rem",
	letterSpacing: 0,
	margin: "0.5rem 0",
	[theme.breakpoints.up("md")]: {
		fontSize: "1rem",
		fontWeight: 700,
	},
	[theme.breakpoints.down("mobile")]: {
		fontWeight: "bold",
	},
	[theme.breakpoints.up("lg")]: {
		fontSize: "1.75rem",
		fontWeight: 700,
	},
	[theme.breakpoints.up("xl")]: {
		fontSize: "2.375rem",
		fontWeight: 900,
	},
}));

export const Content = styled("div")(({ theme }) => ({
	fontSize: "1rem",
	margin: "0.75rem 0",
	letterSpacing: 0,
	[theme.breakpoints.up("lg")]: {
		fontSize: "1.2rem",
		margin: "1rem 0",
	},
	[theme.breakpoints.up("xl")]: {
		fontSize: "1.5rem",
		margin: "1.25rem 0",
	},
}));

export const RatingContainer = styled(Grid)<{ hideSocial?: boolean }>(({ theme, hideSocial }) => ({
	gridArea: "rating",
	display: "grid",
	// backgroundColor: "#ECEDF0",
	// boxShadow: "0px 15px 40px #77777729",
	borderRadius: "5px",
	opacity: 1,
	[theme.breakpoints.down("md")]: {
		gridTemplateRows: "auto",
		gridTemplateColumns: "auto",
		gridGap: "1em",
		gridTemplateAreas: `${hideSocial ? "" : '"social"'} "rating-comment" "image"`,
	},
	[theme.breakpoints.down("mobile")]: {
		gridTemplateAreas: `"rating-comment"  ${hideSocial ? "" : '"social"'} "image"`,
	},
	[theme.breakpoints.up("md")]: {
		gridTemplateRows: "1.25fr 3fr",
		gridTemplateColumns: "2.5fr 1.5fr",
		gridGap: "1em",
		gridTemplateAreas: `${hideSocial ? "" : '"social image"'}
                        "rating-comment image"`,
		height: "fit-content",
	},
	[theme.breakpoints.up("lg")]: {
		gridGap: "1.25em 1.5em",
	},
	[theme.breakpoints.up("xl")]: {
		gridGap: "2em",
	},
}));

export const ImageContainer = styled(Grid)(({ theme }) => ({
	height: "100%",
	gridArea: "image",
	borderRadius: "5px",
}));

export const Image = styled("img")(({ theme }) => ({
	width: "100%",
	height: "100%",
	boxShadow: "0px 15px 40px #77777729",
	borderRadius: "5px",
	opacity: 1,
}));
